<app-content-modal
  class="hide-overflow"
  [title]="'LOGIN.VERIFY_NUMBER'"
  [buttons]="buttons"
  (closeModal)="close(false)">
  <div class="phone-selection">
    <img src="assets/imgs/ptrab/seleccionar_telefono.svg" />
    <p>
      @if (isSinglePhone) {
        {{ 'TWO_FACTOR.VERIFY_NUMBER.INFO.ONE_PHONE.HEADER' | mTranslate }}
        {{
          'TWO_FACTOR.VERIFY_NUMBER.INFO.ONE_PHONE.ONE_PHONE'
            | mTranslate: { value1: getUniquePhone?.phone | slice: -3 }
        }}
      } @else {
        {{ 'TWO_FACTOR.VERIFY_NUMBER.INFO.INFO' | mTranslate }}
      }
    </p>

    @if (!isSinglePhone) {
      <div class="phone-selection__list">
        @for (phone of availablePhones; track phone.id) {
          <app-item class="radio-input">
            <label (click)="setSelectedPhone(phone.id)">
              <input type="radio" name="phone" [value]="phone.id" />
              {{ phone.phone }}
            </label>
          </app-item>
        }
      </div>
    }

    <p>{{ reminderMessage | mTranslate }}</p>
  </div>
</app-content-modal>
